import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { colors } from 'Constants/Colors';
import { CustomSelectContainer, CustomSelectLabel } from './CustomSelect.styled';

interface Option {
  value: string | number;
  label: string;
}

interface Props {
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  options?: Option[];
  width?: string;
  disabled?: boolean;
}

const CustomSelect = ({
  label,
  value,
  onChange,
  placeholder,
  options = [],
  width = 'fit-content',
  disabled = false,
}: Props) => {
  return (
    <CustomSelectContainer style={{ width }}>
      <CustomSelectLabel hidden={!label}>{label}</CustomSelectLabel>
      <Select
        value={value === undefined || value === null ? '' : value}
        onChange={onChange}
        displayEmpty
        variant="standard"
        disabled={disabled}
        disableUnderline
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: '300px',
              '& .MuiMenuItem-root': {
                color: 'black',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                padding: '0 16px',
                fontSize: '1rem',
                '&.Mui-selected': {
                  backgroundColor: `${colors.PRIMARY}20`,
                  '&:hover': {
                    backgroundColor: `${colors.PRIMARY}30`,
                  },
                },
                '&:hover': {
                  backgroundColor: `${colors.PRIMARY}10`,
                },
              },
            },
          },
        }}
        sx={{
          height: '50px',
          minWidth: '120px',
          '& .MuiSelect-select': {
            color: value !== null && value !== undefined ? 'black' : colors.GRAY,
            height: '50px !important',
            lineHeight: '50px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            minWidth: 'auto',
            display: 'flex',
            alignItems: 'center',
            fontSize: '1rem',
            background: 'transparent !important',
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: '24px',
          },
          '& .MuiSelect-icon': {
            color: colors.PRIMARY,
            top: 'calc(50% - 12px)',
          },
        }}
        renderValue={selected => {
          if (selected === '') {
            return <span style={{ color: colors.GRAY_LIGHT }}>{placeholder}</span>;
          }
          const selectedOption = options.find(opt => opt.value === selected);
          return selectedOption?.label || selected;
        }}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </CustomSelectContainer>
  );
};

export default CustomSelect;
